exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info[data-v-21fd4d7a] .el-form-item__content{margin-left:12px !important}.info[data-v-21fd4d7a] .el-alert{padding:6px 20px}[data-v-21fd4d7a] .el-dialog__wrapper{background-color:rgba(0,0,0,0.6)}.dialog-footer[data-v-21fd4d7a]{padding-top:20px;border-top:1px solid #e6ebf5;text-align:right}\n", ""]);

// exports
